<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="half-title">CAMEL PILOT SUPREME</p>
<p class="sub_title">CAPTAIN D.V. ARMSTRONG DFC</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_title_page.vue?1f8a3285